/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-undef */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import { ButtonView, Strong } from './styls';

interface Props {
  icon: JSX.Element;
  text: string;
  isLoading: boolean;
  onPress: Function;
}

const ButtonWithIcon: React.FC<Props> = ({ icon, text, onPress }) => (
  <ButtonView onClick={() => onPress()}>
    {icon}
    <Strong>{text}</Strong>
  </ButtonView>
);
export default ButtonWithIcon;
